if (!customElements.get('product-usp')) {
  class ProductUsp extends HTMLElement {
    selectors = {
      clip: '[data-clip]',
      buttons: '[data-buttons]',
    };

    config = {
      slidesPerView: 1,
      spaceBetween: 20,
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.clip = this.querySelector(this.selectors.clip);
      this.buttons = this.querySelector(this.selectors.buttons);

      if (this.buttons) {
        this.config = Object.assign(this.config, {
          navigation: {
            prevEl: this.buttons.children[0],
            nextEl: this.buttons.children[1],
          },
        });
      }

      this.swiperInstance = new Swiper(this.clip, this.config);
    }
  }

  customElements.define('product-usp', ProductUsp);
}
